import { breakpoints } from 'style'
import styled from 'styled-components'

export const HomeHeroContainer = styled.div`
  position: relative;
  width: 100%;
  /* height: 800px; */
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  height: calc(100vw / 2.5);
  min-height: 300px;
  &::before {
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(13, 0, 0, 0.47);
    z-index: 1;
  }
  .carousel {
    width: 100%;
    height: 100%;
    .carousel-indicators {
      display: none;
    }
    .carousel-inner {
      height: 100%;
      .carousel-item {
        height: 100%;
        z-index: 0;
        img {
          /* min-height: 297px; */
          width: 100%;
        }
      }
    }
  }
  .container {
    z-index: 2;
    position: absolute;
    .home-header-content {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      h1 {
        margin-bottom: 35px;
        color: white;
        line-height: 0.95;
      }
      h3 {
        margin-bottom: 43px;
        color: white;
      }
      .btns-wrapper {
        button {
          width: 230px;
          &.btn-get-started {
            margin-right: 20px;
          }
        }
      }
    }
  }
  @media (max-width: ${breakpoints.xl}px) {
    .container {
      .home-header-content {
        h1 {
          margin-bottom: 39px;
          font-size: 36px;
        }
        h3 {
          margin-bottom: 30px;
        }
        .btns-wrapper {
          button {
            &.btn-get-started {
              margin-bottom: 12px;
            }
          }
        }
      }
    }
  }
  @media (max-width: ${breakpoints.md}px) {
    .container {
      .home-header-content {
        h1 {
          margin-bottom: 39px;
          font-size: 36px;
        }
        h3 {
          margin-bottom: 30px;
        }
        .btns-wrapper {
          button {
            &.btn-get-started {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
  @media (max-width: ${breakpoints.sm}px) {
    .carousel {
      .carousel-inner {
        .carousel-item {
          img {
            max-height: 297px;
            width: auto;
          }
        }
      }
    }
    .container {
      .home-header-content {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        h1 {
          margin-bottom: 39px;
          font-size: 26px;
          max-width: 60%;
        }
        h3 {
          display: none;
        }
        .btns-wrapper {
          button {
            width: 152px;
            height: 48px;
            &.btn-watch {
              /* display: none; */
            }
          }
        }
      }
    }
  }
  @media (max-width: 413px), (max-height: 845px) {
  }
`

export const HeroImgContainer = styled.div`
  height: 100%;
  background-image: url(${(props) => props.bg});
  background-size: cover;
  background-position: center;
`
